/**
 * 获取音频文件的真实时长（秒）
 * 使用 HTMLAudioElement 加载音频元数据
 * @param audioUrl 音频文件 URL
 * @returns Promise<number> 音频时长（秒）
 */
export const getAudioDuration = (audioUrl: string): Promise<number> => {
  return new Promise((resolve, reject) => {
    const audio = document.createElement('audio');

    audio.onloadedmetadata = () => {
      resolve(audio.duration);
    };

    audio.onerror = () => {
      reject(new Error('Failed to load audio'));
    };

    audio.preload = 'metadata';
    audio.src = audioUrl;
  });
};
